import {
  type RouteRecordRaw,
  createWebHistory,
  createRouter,
} from "vue-router";

export const constantRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "HomePage",
    component: () => import("@/pages/homePage/index.vue"),
    meta: {
      title: "欢迎来到可梦AI",
    },
  },
  {
    path: "/play-ground/:pageFrom?",
    name: "PlayGround",
    component: () => import("@/pages/playGround/index.vue"),
    meta: {
      title: "选择使用的AI模型",
    },
  },
  {
    path: "/chat",
    name: "Chat",
    component: () => import("@/pages/chat/index.vue"),
    meta: {
      title: "聊天页",
    },
  },
  {
    path: "/personal",
    name: "Personal",
    component: () => import("@/pages/personal/personal.vue"),
    meta: {
      title: "个人中心",
    },
  },
  {
    path: "/recharge",
    name: "Recharge",
    component: () => import("@/pages/recharge/index.vue"),
    meta: {
      title: "会员充值",
    },
  },

  {
    path: "/wx-pay",
    name: "RechargeWxPay",
    component: () => import("@/pages/pay/index.vue"),
    meta: {
      title: "微信充值",
    },
  },
  {
    path: "/recharge-more",
    name: "RechargeMore",
    component: () => import("@/pages/recharge/more.vue"),
    meta: {
      title: "会员充值",
    },
  },
  {
    path: "/integral",
    name: "Integral",
    component: () => import("@/pages/Integral/index.vue"),
    meta: {
      title: "积分充值",
    },
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
  {
    path: "/master",
    name: "master",
    component: () => import("@/pages/master/index.vue"),
    meta: {
      title: "大师课",
    },
  },
  {
    path: "/plan",
    name: "plan",
    component: () => import("@/pages/plan/index.vue"),
    meta: {
      title: "学习计划",
    },
  },
  {
    path: "/diagnosis",
    name: "diagnosis",
    component: () => import("@/pages/diagnosis/index.vue"),
    meta: {
      title: "学情测评",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  strict: false,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});
// router.beforeEach(async (to, from, next) => {
//     console.log('output=> to', to)
//     console.log('output=> from', from)
//     next();
// });

export default router;
